import React, { useState } from 'react'
import styles from './styles.module.css'

function Colors ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const colorsToShow = isExpanded
    ? record.colors
    : record.colors?.slice(0, 3) || []

  return (
    <div className={styles.rawCategoriesContainer}>
      <h1 className={styles.rawCategoriesTitle}>Colors</h1>

      <div className={styles.rawCategoriesList}>
        {colorsToShow.length > 0 ? (
          colorsToShow.map((category, index) => (
            <span key={index} className={styles.rawCategoriesItem}>
              {category}
            </span>
          ))
        ) : (
          <span className={styles.noRawCategories}>N/A</span>
        )}
      </div>

      {record.colors && record.colors.length > 3 && (
        <button className={styles.rawCategoriesButton} onClick={toggleExpand}>
          {isExpanded
            ? 'Show less'
            : `Expand all (${record.colors.length})`}
        </button>
      )}
    </div>
  )
}

export default Colors
